import React, { Component } from 'react'
import { selectors, actions } from '../sagas/reservation/index'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Order from './Order'
import IndexHeader from './IndexHeader'
import { BottomRow } from '../shared/BottomRow'
import IndexSearch from './IndexSearch'
import { ScrollSync } from 'react-scroll-sync'
import { NewButton } from '../shared/NewButton'
import NoReservations from './noReservations'
import '../stylesheets/reservations/index.sass'

class ReservationIndex extends Component {
  componentDidMount () {
    this.props.getReservations()
  }

  render () {
    return (
      <div>
        { this.props.reservations &&
          <IndexSearch
            filter={ this.selectFilter }
            query={ this.query }
          />
        }
        <ScrollSync>
          <div>
            { this.props.reservations &&
              <div>
                <IndexHeader />
                { this.props.reservations &&
                  this.props.reservations.map(reservation => {
                    return (
                      <Order
                        key={reservation.id}
                        reservation={reservation}
                      />
                    )
                  })
                }
                <BottomRow extra_class={'bottom-row-5'}/>
              </div>
            }
            { this.props.loaded
              && this.props.reservations === undefined &&
              <NoReservations
                company_id={ this.props.company_id }
              />
            }
          </div>
        </ScrollSync>
      </div>
    )
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

const mapStateToProps = (store) => ({
  reservation_store: selectors.reservations_store(store),
  reservations: selectors.reservations(),
  loaded: selectors.loaded(store)
})

export default (connect(mapStateToProps, mapDispatchToProps)(ReservationIndex))



// WEBPACK FOOTER //
// ./src/Reservations/index.jsx